module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGb19b3156911d708d7021a7e799ab7148.b19b3156.png";